// TypingAnimation.js
import React, { useState, useEffect } from 'react';

const TypingAnimation = ({ textArray, typingSpeed = 100 }) => {
  const [displayText, setDisplayText] = useState('');
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const typeText = () => {
      if (index < textArray.length) {
        setDisplayText((prevText) => prevText + textArray[index].charAt(prevText.length));
      }
    };
    
    const interval = setInterval(typeText, typingSpeed);
    if (displayText === textArray[index]) {
      clearInterval(interval);
      if (index < textArray.length - 1) {
        setIndex(index + 1);
        setDisplayText('');
      }
    }

    return () => clearInterval(interval);
  }, [displayText, index, textArray, typingSpeed]);

  return <span>{displayText}</span>;
};

export default TypingAnimation;
